// User-facing texts (Persian only for now: they can move into i18n later)
export const COURSE_MESSAGES = {
    courses: "دوره‌ها",
    loadingList: "در حال بارگذاری دوره‌ها...",
    listFailed: "دریافت دوره‌ها با مشکل مواجه شد.",
    listEmpty: "هنوز دوره‌ای منتشر نشده است.",

    loadingCourse: "در حال بارگذاری دوره...",
    courseFailed: "دریافت دوره با مشکل مواجه شد.",
    courseNotFound: "دوره مورد نظر پیدا نشد.",
    enrollFailed: "ثبت‌نام در دوره انجام نشد. لطفاً دوباره تلاش کنید.",

    difficultyLabel: "سطح دوره:",
    description: "توضیحات",
    syllabus: "سرفصل‌ها",
    noSyllabus: "سرفصلی برای این دوره ثبت نشده است.",

    users: "تعداد کاربران",
    lessons: "تعداد درسنامه",
    projects: "تعداد پروژه",
    category: "دسته‌بندی",

    goToCourse: "برو به دوره",
    enroll: "ثبت‌نام در دوره",

    purchase: "خرید دوره",
    purchaseSeoTitle: (title: string) => `خرید ${title}`,
    purchaseSeoDescription: (title: string) => `خرید دوره ${title} در کدپرو`,
    course: "دوره",
    lessonsShort: "درسنامه",
    projectsShort: "پروژه",
    gateway: "درگاه پرداخت",
    zarinpal: "زرین‌پال",
    payable: "مبلغ قابل پرداخت",
    toman: "تومان",
    payAndStart: "پرداخت و شروع دوره",
    securePayment: "پرداخت امن از طریق زرین‌پال",
    faq: "سوالات متداول",
    noFaq: "سوالات متداولی برای این دوره ثبت نشده است.",

    defaultDescription: (title: string) => `دوره آموزش ${title} در کدپرو`
};